import { render, staticRenderFns } from "./BaseNewProductForm.vue?vue&type=template&id=1c7ffc7a"
import script from "./BaseNewProductForm.vue?vue&type=script&lang=js"
export * from "./BaseNewProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports